// extracted by mini-css-extract-plugin
export default {"successButton":"styles__successButton___fN0mf"};